import "./index.scss"

import React from "react"
import PropTypes from "prop-types"
import BEMHelper from "react-bem-helper"

const bem = new BEMHelper("icon")

const ICONS = {
  menu: [32, 32],
  download: [32, 32],
  speakers: [32, 32],
  sensor: [32, 32],
  settings: [32, 32],
  music: [32, 32],
  volume: [32, 32],
  users: [32, 32],
  externalLink: [32, 32],
  close: [32, 32],
  waved: [32, 32],
}

const Icon = ({ icon, direction, className, title, fill, accepted, rejected, pending }) => {
  if (!ICONS[icon]) {
    console.warn(`Icon ${icon} does not exist`)
    return null
  }

  const [width, height] = ICONS[icon]
  const viewBox = `0 0 ${width} ${height}`

  return (
    <svg
      width={`${width}px`}
      height={`${height}px`}
      viewBox={viewBox}
      {...bem(
        "",
        {
          [icon]: icon,
          [direction]: direction,
        },
        className,
        pending,
        accepted,
        rejected,
        fill
      )}
    >
      {title && <title>{title}</title>}

      {icon === "menu" && (
        <g>
          <line {...bem("line")} x1="1" y1="10" x2="31" y2="10" />
          <line {...bem("line")} x1="1" y1="22" x2="31" y2="22" />
        </g>
      )}


      {icon === "download" && (
        <g>
          <path {...bem("line")} d="M16 4L16 23" />
          <path {...bem("line")} d="M26 14L16 24L6 14" />
          <path {...bem("line")} d="M6 30L26 30" />
        </g>
      )}

      {icon === "speakers" && (
        <g>
          <path d="M20.5 25C22.433 25 24 23.433 24 21.5C24 19.567 22.433 18 20.5 18C18.567 18 17 19.567 17 21.5C17 23.433 18.567 25 20.5 25Z" {...bem("line")} />
          <path d="M30 6H11V30H30V6Z" {...bem("line")} />
          <path d="M7 30H2V11H7" {...bem("line")} />
          <path d="M20.5 14C21.8807 14 23 12.8807 23 11.5C23 10.1193 21.8807 9 20.5 9C19.1193 9 18 10.1193 18 11.5C18 12.8807 19.1193 14 20.5 14Z" {...bem("fill")} />
        </g>
      )}

      {icon === "sensor" && (
        <g>
          <path d="M21.0667 28H8.93333C5.12 28 2 24.88 2 21.0667V8.93333C2 5.12 5.12 2 8.93333 2H21.0667C24.88 2 28 5.12 28 8.93333V21.0667C28 24.88 24.88 28 21.0667 28Z" {...bem("line")} />
        </g>
      )}

      {icon === "settings" && (
        <g>
          <path d="M5 30V19" {...bem("line")} />
          <path d="M5 13V2" {...bem("line")} />
          <path d="M16 30V16" {...bem("line")} />
          <path d="M16 10V2" {...bem("line")} />
          <path d="M27 30V22" {...bem("line")} />
          <path d="M27 16V2" {...bem("line")} />
          <path d="M0 18H10" {...bem("line")} />
          <path d="M11 11H20" {...bem("line")} />
          <path d="M22 21H32" {...bem("line")} />
        </g>
      )}

      {icon === "music" && (
        <g>
          <path d="M22.6 25.6C24.6435 25.6 26.3 23.9435 26.3 21.9C26.3 19.8565 24.6435 18.2 22.6 18.2C20.5565 18.2 18.9 19.8565 18.9 21.9C18.9 23.9435 20.5565 25.6 22.6 25.6Z" {...bem("line")} />
          <path d="M12.4 24.8V7.5L26.3 4.5V21.9" {...bem("line")} />
          <path d="M8.7 28.4C10.7435 28.4 12.4 26.7435 12.4 24.7C12.4 22.6565 10.7435 21 8.7 21C6.65655 21 5 22.6565 5 24.7C5 26.7435 6.65655 28.4 8.7 28.4Z" {...bem("line")} />
        </g>
      )}


      {icon === "volume" && (
        <g>
          <path d="M13 7.1L6.6 12.2H1.5V19.9H6.6L13 25V7.1Z" {...bem("line")} />
          <path d="M25.5 4.1C32.1 10.7 32.1 21.5 25.5 28.1" {...bem("line")} />
          <path d="M19 10.1C22.3 13.4 22.3 18.8 19 22.1" {...bem("line")} />
        </g>
      )}


            {icon === "users" && (
              <g>
              <path d="M9.7309 14C12.2162 14 14.2309 11.9853 14.2309 9.5C14.2309 7.01472 12.2162 5 9.7309 5C7.24562 5 5.2309 7.01472 5.2309 9.5C5.2309 11.9853 7.24562 14 9.7309 14Z" {...bem("line")} />
              <path d="M18.0979 6.11647C18.8479 5.36647 19.9729 4.99147 21.0979 4.99147C23.5354 4.99147 25.5979 7.05397 25.5979 9.49147C25.5979 11.929 23.5354 13.9915 21.0979 13.9915C19.9729 13.9915 18.8479 13.6165 18.0979 12.8665" {...bem("line")} />
              <path d="M17 31V20H2.5V31" {...bem("line")} />
              <path d="M29 31V20H21" {...bem("line")} />
              </g>
            )}


            {icon === "externalLink" && (
              <g>
                <path d="M14.5234 19.4766L26.5234 7.47659" {...bem("line")} />
                <path d="M17.4677 6.99998L27 6.99998L27 16.5323" {...bem("line")} />
                <path d="M22 20.5V29H5V12H13.5" {...bem("line")} />

              </g>
            )}

            {icon === "close" && (
              <g>
                <path d="M27 5.00001L5.00002 27" {...bem("line")} />
                <path d="M5 5.00001L27 27" {...bem("line")} />
              </g>
            )}


            {icon === "waved" && (
              <g>
                  <path d="M0 10C1.52 10 2.8 11.08 3.08 12.56L4.92 22.44C5.2 23.92 6.48 25 8 25C9.52 25 10.8 23.92 11.08 22.44L12.92 12.56C13.2 11.08 14.48 10 16 10C17.52 10 18.8 11.08 19.08 12.56L20.92 22.44C21.2 23.92 22.48 25 24 25C25.52 25 26.8 23.92 27.08 22.44L28.92 12.56C29.2 11.08 30.48 10 32 10" {...bem("line")} />
              </g>
            )}

    </svg>
  )
}

Icon.propTypes = {
  icon: PropTypes.oneOf(Object.keys(ICONS)).isRequired,
  color: PropTypes.string,
  direction: PropTypes.string,
  className: PropTypes.string,
  fill: PropTypes.bool,
  pending: PropTypes.bool,
  accepted: PropTypes.bool,
  rejected: PropTypes.bool,
  title: PropTypes.string,
}

export default Icon
